import { applicationContextActionCreator } from '../store/actions';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import ServiceBase from './ServiceBase';

class CodingEventService extends ServiceBase {
    async getEvents(queryItems) {
        var result = await this.requestJson({
            url: '/api/admin/codingevent/query',
            method: "GET",
            data: queryItems
        });

        return result;
    }

    async getEvent(id) {
        var result = await this.requestJson({
            url: `/api/admin/codingevent/${id}`,
            method: "GET"
        });

        return result;
    }
    //url: `/api/admin/codingevent/${file.codingEventID}/file/${file.id}`
    async getFile(codingEventId, id) {

        let callResponse = undefined;

        let webapi = `api/admin/codingevent/${codingEventId}/file/${id}`;
        const token = this.getToken();
        callResponse = fetch(webapi,
                {
                    method: 'GET',
                    headers: {
                        responseType: 'blob',
                        authorization: token
                    }
                })
            .then(response =>
                response.blob()
            )
            .then(blob => {
                if (blob.size > 0) {
                    let objUrl = URL.createObjectURL(blob);
                    return { result: true, model: objUrl };
                } else {
                    return { result: false };
                }
            }) ;

        return callResponse;
    }

    async createFile(file, codingEventId) {
        var result = await this.sendFormData({
            url: `/api/admin/codingevent/${codingEventId}/file/`,
            method: "POST",
            data: file
        });

        return result;
    }

    async deleteFile(fileId, codingEventId) {
        var result = await this.requestJson({
            url: `/api/admin/codingevent/${codingEventId}/file/${fileId}`,
            method: "DELETE"
        })
        return result;
    }

    async addNote(note, codingEventId) {
        var result = await this.requestJson({
            url: `/api/admin/codingevent/${codingEventId}/note`,
            method: "POST",
            data: note
        });
        return result;
    }

    async deleteNote(noteId, codingEventId) {
        var result = await this.requestJson({
            url: `/api/admin/codingevent/${codingEventId}/note/${noteId}`,
            method: "DELETE"
        })
        return result;
    }

    async saveEvent(codingEvent) {
        var result = await this.requestJson({
            url: `/api/admin/codingevent/${codingEvent.id}`,
            method: "PUT",
            data: codingEvent
        });
        return result;
    }

    async bulkSaveEvents(codingEvents) {
        var result = await this.requestJson({
            url: '/api/admin/codingevents',
            method: "PUT",
            data: codingEvents
        });

        return result;
    }

    async importCodingEvents(data) { //sendFormData
        var result = await this.sendFormData({
            url: "/api/admin/codingevent/import",
            method: "POST",
            data: data
        });
        return result;
    }

    async getImportViewModel() {
        var result = await this.requestJson({
            url: '/api/admin/codingevent/import',
            method: "GET"
        });
        return result;
    }
}

export default CodingEventService